import { GoLinksViewItemComponent } from './go-links-view-item/go-links-view-item.component';
import { ResultsModule } from '../../results/results.module';
import { GoLinksPopupComponent } from './go-links-popup/go-links-popup.component';
import { NgModule } from '@angular/core';
import { GoLinksEmptyStateComponent } from './go-links-empty-state/go-links-empty-state.component';

const components = [GoLinksViewItemComponent, GoLinksPopupComponent, GoLinksEmptyStateComponent];
@NgModule({
  declarations: components,
  imports: [ResultsModule],
  exports: [...components, ResultsModule],
})
export class GoLinksViewModule {}
